import { Component, ViewChild } from '@angular/core';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { GlobalService } from '../../services/global.service';
import { DivisionService } from '../../services/division.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownService } from '../../services/dropdown.service';
import { ButtonComponent } from "../../components/button/button.component";
import { SearchInputComponent } from "../../components/search-input/search-input.component";
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { BulkUploadComponent } from "../../components/bulk-upload/bulk-upload.component";
import { HeaderComponent } from "../../components/header/header.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { PermissionService } from '../../services/permission.service';
import { ValidationService } from '../../services/validation.service';

@Component({
  selector: 'app-permission-page',
  imports: [ButtonComponent, SearchInputComponent, SelectInputComponent, TextInputComponent, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, BulkUploadComponent, HeaderComponent, PluralPipe, ReactiveFormsModule],
  templateUrl: './permission-page.component.html',
  styleUrl: './permission-page.component.css'
})

export class PermissionPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any

  page_name = 'Permission';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];

  columns: any = [
     { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'Module.name', headerName: 'Module', filter: true, flex: 1, },
    { field: 'SubModule.name', headerName: 'Sub Module', filter: true, flex: 1, },
    { field: 'name', headerName: 'Permission', filter: true, flex: 1, },
    { field: 'permission_slug', headerName: 'Permission Slug', filter: true, flex: 1, },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'country_id', sample_value: 'India' },
    { column_name: 'State Name', type: 'text', return_as: 'state_id', sample_value: 'Maharashtra' },
    { column_name: 'Division Name', type: 'text', return_as: 'name', sample_value: 'Mumbai' },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'Mumbai' },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ps: PermissionService, public ar: ActivatedRoute, public dds: DropdownService,public vs:ValidationService) {
    this.form = this.fb.group({
      module_id: ['', [Validators.required]],
      sub_module_id: ['', [Validators.required]],
      name: ['', [Validators.required,Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      permission_slug: ['', [Validators.required]],
      is_active:[true]
    });
  }
  async ngOnInit() {
    await this.dds?.get_dropdown_list(['module', 'sub_module']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }
  async get_list(filter?: any) {
    try {
     const res = await this.ps.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async delete() {
    let res = await this.ps.delete(this.selected_ids.id);
    this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    this.selected_ids = {};
    this.confirmation_delete_modal?.close()
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.ps.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.ps.get(item.id);
      this.selected_ids = { ...response.data };
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    let form_value = this.form.value;
      form_value.is_active = true
    if (this.selected_ids && this.selected_ids.id) {
      let update_response = await this.ps.update(this.selected_ids.id, form_value);
      this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
    } else {
      let create_response = await this.ps.add(form_value);
      this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
    }
    await this.get_list(this.params);
    this.close_form_modal();
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(data, this.ps, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }

}
